import { render, staticRenderFns } from "./SitesBuilderTokens.vue?vue&type=template&id=dcbdb1f8"
import script from "./SitesBuilderTokens.vue?vue&type=script&lang=js"
export * from "./SitesBuilderTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports